// extracted by mini-css-extract-plugin
module.exports = {"coverPhoto":"styles_coverPhoto__HLEr_","blurredBackgroundImage":"styles_blurredBackgroundImage__eOKZM"};